/* ============================================================
   Cart-Upsell JS  -  GMS
   Global eingebunden via theme.liquid (vor </body>).
   Deckt BEIDE Flaechen ab:
     - Warenkorbseite  [data-cart-upsell]
     - Cart-Drawer     [data-cart-upsell-drawer]   (Vue x-template)

   Verhalten (Best Practice fuer Upsell):
   - Einfacher "Hinzufuegen"-Button -> ein Klick legt das Produkt
     in den Warenkorb (quantity 1).
   - Produkt poppt oben in der Liste auf, Menge steuert man dort.
   - Die Empfehlungskarte wird danach ausgeblendet (liegt ja jetzt
     im Warenkorb) -> kein doppelter Mengen-Zaehler.
   ============================================================ */
(function () {
  'use strict';

  var CART_UPDATE_EVENT = 'wetheme-cart-update';
  var TOGGLE_DRAWER_EVENT = 'wetheme-toggle-right-drawer';

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function addToCart(variantId, button) {
    if (!variantId) return;
    var isDrawer = !!button.closest('[data-cart-upsell-drawer]');
    var original = button.innerHTML;
    button.disabled = true;
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('cart/add failed: ' + res.status);
      return res.json();
    })
    .then(function () {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.innerHTML = '\u2713 Hinzugef\u00fcgt';
      return getCart();
    })
    .then(function (cart) {
      if (!cart) return;

      if (isDrawer) {
        // Drawer-Liste reaktiv neu rendern (gleiches Event wie das Theme)
        document.documentElement.dispatchEvent(new CustomEvent(TOGGLE_DRAWER_EVENT, {
          detail: { type: 'cart', forceOpen: true, params: { cart: cart } }
        }));
      } else {
        document.documentElement.dispatchEvent(new CustomEvent(CART_UPDATE_EVENT, {
          detail: { cart: cart }
        }));
        refreshCartPage();
      }

      // Karte ausblenden: Produkt liegt jetzt im Warenkorb
      var card = button.closest('.cart-upsell__card');
      if (card) {
        card.style.transition = 'opacity .35s ease, transform .35s ease';
        card.style.opacity = '0';
        card.style.transform = 'translateX(10px)';
        window.setTimeout(function () {
          card.style.display = 'none';
          hideEmptyBlocks();
        }, 360);
      }
    })
    .catch(function (err) {
      console.error('[cart-upsell]', err);
      button.classList.remove('is-loading');
      button.disabled = false;
      button.innerHTML = original;
    });
  }

  function refreshCartPage() {
    if (!document.querySelector('.cart-table')) return;
    fetch(window.location.pathname, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newTable = doc.querySelector('.cart-table');
        var oldTable = document.querySelector('.cart-table');
        if (newTable && oldTable) oldTable.parentNode.replaceChild(newTable, oldTable);
        var newSub = doc.querySelector('.cart__subtotal');
        var oldSub = document.querySelector('.cart__subtotal');
        if (newSub && oldSub) oldSub.innerHTML = newSub.innerHTML;
      })
      .catch(function () {});
  }

  // Produkte, die bereits im Warenkorb liegen, gar nicht erst anzeigen
  function hideInCartItems(cart) {
    if (!cart || !cart.items) return;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[String(i.product_id)] = true; });
    document.querySelectorAll('.cart-upsell__card').forEach(function (card) {
      var pid = card.getAttribute('data-product-id');
      card.style.display = (pid && inCart[pid]) ? 'none' : '';
    });
    hideEmptyBlocks();
  }

  // Bloecke ohne sichtbare Karten ausblenden
  function hideEmptyBlocks() {
    document.querySelectorAll('.cart-upsell__block').forEach(function (block) {
      // Den per CSS ausgeblendeten Wein-Block nicht anfassen
      if (block.classList.contains('cart-upsell__block--wines')) return;
      var visible = 0;
      block.querySelectorAll('.cart-upsell__card').forEach(function (c) {
        if (c.style.display !== 'none') visible++;
      });
      block.style.display = visible ? '' : 'none';
    });
  }

  function syncFromServer() {
    if (!document.querySelector('.cart-upsell__card')) return;
    getCart().then(hideInCartItems).catch(function () {});
  }

  // Klick-Delegation auf document (faengt auch den erst spaeter gerenderten Drawer)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.getAttribute('data-variant-id'), btn);
  });

  document.documentElement.addEventListener(CART_UPDATE_EVENT, function (e) {
    if (e.detail && e.detail.cart) hideInCartItems(e.detail.cart);
  });

  // Drawer beim Oeffnen synchronisieren
  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-drawer-open-right-link, .site-header__cart-toggle')) {
      window.setTimeout(syncFromServer, 600);
    }
  });

  if (document.readyState !== 'loading') {
    syncFromServer();
  } else {
    document.addEventListener('DOMContentLoaded', syncFromServer);
  }
})();
